/*=========================================================================================
  File Name: moduleChatActions.js
  Description: Chat Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
    setChatSearchQuery({ commit }, query){
        commit('SET_CHAT_SEARCH_QUERY', query)
    },
    updateAboutChat({ commit, rootState }, value) {
        commit('UPDATE_ABOUT_CHAT', {rootState: rootState, value: value})
    },
    updateStatusChat({ commit, rootState }, value) {
        commit('UPDATE_STATUS_CHAT', {rootState: rootState, value: value})
    },

    // API CALLS

    array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
    },

    sendChatMessage({ getters, commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          user_id : payload.id,
          message : payload.msg.textContent,
        }

        axios.post("/api/admin/sendMessage", data)
          .then((response) => {
            payload.chatData = getters.chatDataOfUser(payload.id)
            commit('SEND_CHAT_MESSAGE', payload)

            // if(!payload.chatData) { 
            //   const chatContactsArray = getters.contacts.filter((contact) => {
            //     if(getters.chats[contact.uid]) return (getters.chats[contact.uid])
            //   })

            //   commit('UPDATE_CHAT_CONTACTS', chatContactsArray) 
            // }




            const chatContactsArray = getters.contacts.filter((contact) => {
              if(getters.chats[contact.uid]) return (getters.chats[contact.uid])
            })

            commit('UPDATE_CHAT_CONTACTS', chatContactsArray) 

            // var chats = {};
            // var chatContact = [];
            // var contacts = [];

            // console.log("chat list")
            // console.log(response.data.response.original.chat)

            // for (const entry of response.data.response.original.chat){
            //   let messageTime = new Date(entry.created_at)
            //   let uid = (entry.type == "receive") ? entry.sender_id : entry.receiver_id
            //   chats[uid] =  {
            //     isPinned: false,
            //     msg: [{
            //       textContent: entry.message,
            //       time: messageTime.toString(),
            //       isSent: (entry.type == "receive") ? false : true,
            //       isSeen: true,
            //     }],
            //   }

            //   if(entry.sender || entry.receiver){
            //     chatContact.push({
            //       uid : uid,
            //       displayName : (entry.type == "receive") ? entry.sender.name : entry.receiver.name,
            //       photoURL : (entry.type == "receive") ? entry.sender.image : entry.receiver.image,
            //       // status : (entry.type == "receive") ? entry.sender.lastSeenAgo : entry.receiver.lastSeenAgo,
            //       about : 'Toffee caramels jelly-o tart gummi bears cake I',
            //       status: 'online'
            //     })

            //     var contactUser = (entry.type == "receive") ? entry.sender : entry.receiver;
            //     contactUser.uid = contactUser.id
            //     contactUser.displayName = contactUser.name
            //     contactUser.photoURL = contactUser.image
            //     contactUser.lastSeenAgo = contactUser.lastSeenAgo
            //     contacts.push(contactUser);
            //   }
            // }

            // commit('UPDATE_CONTACTS', contacts)
            // commit('UPDATE_CHATS', chats)
            // commit('UPDATE_CHAT_CONTACTS', chatContact)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },

    // Get contacts from server. Also change in store
    fetchContacts({ commit }) {
      return new Promise((resolve, reject) => {
        axios.post("/api/admin/getAllMessage", {params: {q: ""}})
          .then((response) => {
            response.data.contact.forEach(function(entry) {
              entry.uid = entry.id
              entry.displayName = entry.name
              entry.photoURL = entry.image
              entry.LastSeen = entry.lastSeenAgo
              entry.about = 'Toffee caramels jelly-o tart gummi bears cake I'
              entry.status = 'online'
            });

            var chats = {};
            var chatContact = [];
            var contacts = response.data.contact;
            for (const entry of response.data.chat){
              let messageTime = new Date(entry.created_at)
              let uid = (entry.type == "receive") ? entry.sender_id : entry.receiver_id
              chats[uid] =  {
                isPinned: false,
                msg: [{
                  textContent: entry.message,
                  time: messageTime.toString(),
                  isSent: (entry.type == "receive") ? false : true,
                  isSeen: true,
                }],
              }

              if(entry.sender || entry.receiver){
                chatContact.push({
                  uid : uid,
                  displayName : (entry.type == "receive") ? entry.sender.name : entry.receiver.name,
                  photoURL : (entry.type == "receive") ? entry.sender.image : entry.receiver.image,
                  // status : (entry.type == "receive") ? entry.sender.lastSeenAgo : entry.receiver.lastSeenAgo,
                  about : 'Toffee caramels jelly-o tart gummi bears cake I',
                  status: 'online'
                })
              }
            }

            


            // const chatContactsArray = contacts.filter((contact) => {

            //   if(chats[contact.uid]) return (chats[contact.uid])
            // })

            // console.log(chatContact)



            commit('UPDATE_CONTACTS', contacts)
            commit('UPDATE_CHATS', chats)
            // commit('UPDATE_CHAT_CONTACTS', chatContact)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },

    getMessagesForAUser({ getters, commit, dispatch }, userId) {
      return new Promise((resolve, reject) => {
        axios.post("/api/admin/viewMessage", {user_id: userId})
          .then((response) => {
            if (Array.isArray(response.data)) {
              var chats = {};
              var msg = [];
              var uid = null;

              let messages = [];
              for (const groupMessages of response.data){
                for (const o of groupMessages){
                  messages.push(o);
                }
              }
              messages.sort(function (a, b) {
                return a.id - b.id;
              });

              for (const entry of messages){
                let messageTime = new Date(entry.created_at)
                uid = (entry.type == "receive") ? entry.sender_id : entry.receiver_id
               
                msg.push({
                  textContent: entry.message,
                  time: messageTime.toString(),
                  isSent: (entry.type == "receive") ? false : true,
                  isSeen: true,
                })
              }

              // chats[uid] =  {
              //   isPinned: false,
              //   msg : msg,
              // }

              // chats = getters.chats

              // chats[uid] =  {
              //   isPinned: false,
              //   msg : msg,
              // }
              // console.log(chats)
              // console.log(uid)
              // commit('UPDATE_CHATS', {chats})
              commit('UPDATE_A_USER_CHATS', {userId : uid, message : { isPinned: false, msg : msg,}})
              resolve(response)
            }
          })
          .catch((error) => { reject(error) })
      })
    },

    // Get contacts from server. Also change in store
    fetchChatContacts({ commit }) {
      return new Promise((resolve, reject) => {
        axios.post("/api/admin/getAllMessage", {params: {q: ""}})
          .then((response) => {
            response.data.contact.forEach(function(entry) {
              entry.uid = entry.id
              entry.displayName = entry.name
              entry.photoURL = entry.image
              entry.LastSeen = entry.lastSeenAgo
              entry.about = 'Toffee caramels jelly-o tart gummi bears cake I'
              entry.status = 'online'
            });

            var chats = {};
            var chatContact = [];
            var contacts = response.data.contact;
            for (const entry of response.data.chat){
              let messageTime = new Date(entry.created_at)
              let uid = (entry.type == "receive") ? entry.sender_id : entry.receiver_id
              chats[uid] =  {
                isPinned: false,
                msg: [{
                  textContent: entry.message,
                  time: messageTime.toString(),
                  isSent: (entry.type == "receive") ? false : true,
                  isSeen: true,
                }],
              }
            }

            const chatContactsArray = contacts.filter((contact) => {
              if(chats[contact.uid]) return (chats[contact.uid])
            })

            commit('UPDATE_CHAT_CONTACTS', chatContactsArray)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },

    // fetchChatContacts({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     axios.post("/api/apps/chat/chat-contacts", {params: {q: ""}})
    //       .then((response) => {
    //         // console.log(response.data.chat)
    //         commit('UPDATE_CHAT_CONTACTS', response.data.chat)
    //         resolve(response)
    //       })
    //       .catch((error) => { reject(error) })
    //   })
    // },

    // Get chats from server. Also change in store
    fetchChats({ commit }) {
      return new Promise((resolve, reject) => {
        axios.post("/api/admin/getAllMessage")
          .then((response) => {
            response.data.contact.forEach(function(entry) {
              entry.uid = entry.id
              entry.displayName = entry.name
              entry.photoURL = entry.image
              entry.LastSeen = entry.lastSeenAgo
              entry.about = 'Toffee caramels jelly-o tart gummi bears cake I'
              entry.status = 'online'
            });

            var chats = {};
            var chatContact = [];
            var contacts = [];
            // var contacts = response.data.contact;
            for (const entry of response.data.chat){
              // console.log(response.data.chat)
              let messageTime = new Date(entry.created_at)
              let uid = (entry.type == "receive") ? entry.sender_id : entry.receiver_id
              chats[uid] =  {
                isPinned: false,
                msg: [{
                  textContent: entry.message,
                  time: messageTime.toString(),
                  isSent: (entry.type == "receive") ? false : true,
                  isSeen: (entry.type == "receive" && entry.seen == null) ? false : true,
                }],
              }

              if(entry.sender || entry.receiver){
                chatContact.push({
                  uid : uid,
                  id : uid,
                  displayName : (entry.type == "receive") ? entry.sender.name+' '+entry.sender.last_name : entry.receiver.name+' '+entry.receiver.last_name,
                  photoURL : (entry.type == "receive") ? entry.sender.image : entry.receiver.image,
                  // status : (entry.type == "receive") ? entry.sender.lastSeenAgo : entry.receiver.lastSeenAgo,
                  about : 'Toffee caramels jelly-o tart gummi bears cake I',
                  status: 'online',
                  textContent: entry.message,
                })

                var contactUser = (entry.type == "receive") ? entry.sender : entry.receiver;
                contactUser.uid = contactUser.id
                contactUser.displayName = contactUser.name+' '+contactUser.last_name
                contactUser.photoURL = contactUser.image
                contactUser.lastSeenAgo = contactUser.lastSeenAgo
                contacts.push(contactUser);
              }
            }

            
            commit('UPDATE_CONTACTS', contacts)
            commit('UPDATE_CHATS', chats)
            commit('UPDATE_CHAT_CONTACTS', chatContact)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },

    markSeenAllMessages({ getters, commit }, id) {

      return new Promise((resolve, reject) => {
        axios.post("/api/apps/chat/mark-all-seen", {id: id})
          .then((response) => {
            commit('MARK_SEEN_ALL_MESSAGES', {
              id: id,
              chatData: getters.chatDataOfUser(id)
            })
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },

    toggleIsPinned({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post("/api/apps/chat/set-pinned/", {contactId: payload.id, value: payload.value})
          .then((response) => {
            commit('TOGGLE_IS_PINNED', payload)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
}
